import { render, staticRenderFns } from "./Proprietor.vue?vue&type=template&id=39b64939&scoped=true"
import script from "./Proprietor.vue?vue&type=script&lang=js"
export * from "./Proprietor.vue?vue&type=script&lang=js"
import style0 from "./Proprietor.vue?vue&type=style&index=0&id=39b64939&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b64939",
  null
  
)

export default component.exports